<script setup lang="ts">
import {
  SubmissionJob,
  SubmissionJobType,
} from "~/classes/models/submission-job/submission-job.model";
import { useSubmissionJobs } from "~/stores/useSubmissionJobs.store";

const submissionJobsStore = useSubmissionJobs();
const { submissionJobs } = storeToRefs(submissionJobsStore);

const removeSubmissionJob = (job: SubmissionJob) => {
  useSubmissionJobs().removeSubmissionJob(job);
};

const width = computed(() => {
  return (job: SubmissionJob) => {
    if (job.type == SubmissionJobType.review) {
      return "1500px";
    }
    return "800px";
  };
});
</script>

<template>
  <div>
    <BaseSheetComponent
      v-for="job in submissionJobs"
      :key="job.id"
      :controller="job.sheetController"
      :z-index-override="999"
      :width="width(job)"
      max-width="90%"
      :include-content-padding="false"
      @on-close="removeSubmissionJob(job)"
    >
      <template #content>
        <div class="h-full">
          <UploadStudentSubmissionDialog
            v-if="job.type == SubmissionJobType.additionalInformation"
            :job="job"
            @close="job.sheetController.close()"
          />
          <UploadStudentSubmissionJobsReview
            v-if="job.type == SubmissionJobType.review"
            :job="job"
            @close="job.sheetController.close()"
          />
          <UploadStudentSubmissionJobsAdditionalFiles
            v-if="job.type == SubmissionJobType.additionalFiles"
            :job="job"
            @close="job.sheetController.close()"
          />
        </div>
      </template>
    </BaseSheetComponent>
  </div>
</template>

<style scoped></style>
